import { Injectable } from '@angular/core';
import { RetailItem } from '../model/retail-item';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class RetailItemService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    
    putRetailItem(retailitem) {
      return  this._restClientService.put<RetailItem>(`retail-item/update-retail-item`, retailitem);
    }
    
    
    getListRetailItemByRequest(requestId) {
      return this._restClientService.load<RetailItem[]>('retail-item/retail-item-by-request?requestId='+requestId);
    }
    
    
    getRetailItemById(creditId) {
      return this._restClientService.load<RetailItem>('retail-item/retail-item-by-id/' + creditId);
    }
    
  

}      

    